import { logError } from '../utils/errorLogger';
import BaseApi from './BaseApi';

const ENDPOINT = 'ticket-partenaire';

class TicketPartenaireApi extends BaseApi {
  constructor() {
    super(ENDPOINT);
  }

  async getFilters() {
    const api = this.getApiInstance(true);
    const { data } = await api.get(`/${ENDPOINT}/filters`);
    return data;
  }

  async list(params = {}) {
    const api = this.getApiInstance(true);
    const { data } = await api.get(`/${ENDPOINT}`, { params });
    return data;
  }

  async getById(id) {
    const api = this.getApiInstance(true);
    const { data } = await api.get(`/${ENDPOINT}/${id}`);
    return data;
  }

  async upload(file) {
    const api = this.getApiInstance(true);
    const form = new FormData();
    form.append('file', file);
    const { data } = await api.post(`/${ENDPOINT}/upload`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  }

  async create(payload) {
    const api = this.getApiInstance(true);
    const { data } = await api.post(`/${ENDPOINT}`, payload);
    return data;
  }

  async updateStatus(id, statut) {
    const api = this.getApiInstance(true);
    const { data } = await api.put(`/${ENDPOINT}/${id}/statut`, { statut });
    return data;
  }

  async getMessages(id) {
    const api = this.getApiInstance(true);
    const { data } = await api.get(`/${ENDPOINT}/${id}/messages`);
    return data;
  }

  async addMessage(id, message) {
    const api = this.getApiInstance(true);
    const { data } = await api.post(`/${ENDPOINT}/${id}/messages`, { message });
    return data;
  }
}

export default new TicketPartenaireApi();
